import { LineHeights } from "~/constants/typography";

export const Space = {
    none: 0, // space-0 0px
    xxx: 2, // space-0.5 2px
    xxs: 4, // space-1 4px
    xx: 6, // space-1.5 6px
    xs: 8, // space-2 8px
    sm: 12, // space-3 12px
    md: 16, // space-4 16px
    lg: 24, // space-6 24px
    xl: 32, // space-8 32px
    "10": 40, // space-10 40px
    "12": 48, // space-12 48px
    "14": 56, // space-14 56px
    xxl: 64, // space-16 64px
};
export const Radius = {
    none: 0, // rounded-none 0px
    xs: 2, // rounded-sm 2px
    sm: 4, // rounded 4px
    md: 6, // rounded-md 6px
    lg: 8, // rounded-lg 8px
    xl: 12, // rounded-xl 2px
    xxl: 16, // rounded-2xl 6px
    full: 999, // rounded-full 9px
};
export const Widths = {
    full: "100%",
    half: "50%",
    auto: "auto",
    ...Space,
};
export const INPUT_HEIGHT = Space.sm + LineHeights.base + Space.sm;
